import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';

export interface ToolType {
    _id: string;
    designation: string;
    price: number;
    priceType: number;
    crudStatus: number;
    usageCount?: {
        total: number;
        tools: number;
    };
    displayOrder?: number;
    updatedAt?: string;
    createdAt?: string;
}

export interface ToolsTypesResponse {
    message: string;
    data: ToolType[];
}

export interface ToolTypeResponse {
    message: string;
    data: ToolType;
}

export interface GetToolsTypesQueries {
    active?: boolean;
    withUsage?: boolean;
}

export interface CreateToolTypeBody {
    designation: string;
    price: number;
    priceType: number;
    crudStatus?: number;
    displayOrder?: number | null;
}

export interface UpdateToolTypeBody {
    designation?: string;
    price?: number;
    priceType?: number;
    crudStatus?: number;
    displayOrder?: number | null;
}

// GET ALL
export const getAllToolsTypes = async (queries?: GetToolsTypesQueries): Promise<ToolsTypesResponse> => {
    try {
        const response: AxiosResponse<ToolsTypesResponse> = await apiClient.get('/tool-types', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred while fetching tool types.');
    }
};

export const createToolType = async (data: CreateToolTypeBody): Promise<ToolTypeResponse> => {
    try {
        const response: AxiosResponse<ToolTypeResponse> = await apiClient.post('/tool-types', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred while creating tool type.');
    }
};

// UPDATE
export const updateToolType = async (id: string, data: UpdateToolTypeBody): Promise<ToolTypeResponse> => {
    try {
        const response: AxiosResponse<ToolTypeResponse> = await apiClient.patch(`/tool-types/${id}`, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred while updating tool type.');
    }
};
